export default "__VITE_ASSET__DtGNDOHs__"